export default __webpack_public_path__ + "static/media/border-rounded-complete.3a01bb06.svg";